import React from "react";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Dialog, DialogContent, IconButton, Tooltip } from "@mui/material";

/**
 * Full-size look at one banner before it is made live.
 *
 * The thumbnails in the radio list are the same files scaled down by the
 * browser, so what opens here is exactly what visitors will see — there is no
 * separate preview asset that could disagree with it.
 */
const BannerPreviewDialog = ({ preview, onClose }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={Boolean(preview)}
      onClose={onClose}
      maxWidth="xl"
      fullWidth
      aria-label={preview?.alt || ""}
    >
      <DialogContent className="relative !p-0">
        <div className="absolute right-2 top-2 z-10 flex gap-1">
          <Tooltip title={t("admin.cms.season4.banners.openOriginal")}>
            <IconButton
              component="a"
              href={preview?.src}
              target="_blank"
              rel="noreferrer"
              size="small"
              className="!bg-white/90 hover:!bg-white"
            >
              <OpenInNewIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title={t("admin.cms.season4.banners.close")}>
            <IconButton
              onClick={onClose}
              size="small"
              className="!bg-white/90 hover:!bg-white"
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </div>

        {preview && (
          <img
            src={preview.src}
            alt={preview.alt}
            className="block h-auto w-full"
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default BannerPreviewDialog;
